/**
 * How the chat list stays pinned while an assistant reply grows.
 *
 * A smooth scroll that is restarted on every burst feels like it stutters.
 * Small growth (the live reveal) snaps to the bottom. A single tall jump
 * eases once, and is not restarted unless the content grows past that target.
 */

/** User is pinned while the list is within this many pixels of the end. */
export const SCROLL_FOLLOW_PIN_GAP_PX = 100

/** One-shot jumps at least this tall ease once. Smaller growth snaps. */
export const SCROLL_FOLLOW_EASE_GAP_PX = 96

export type ScrollFollowMode = 'instant' | 'auto'

export type ScrollFollowDecision = 'none' | 'instant' | 'smooth'

export function decideScrollFollow(input: {
  gapPx: number
  mode: ScrollFollowMode
  prefersReducedMotion: boolean
  /** scrollTop a smooth scroll is already heading toward, or null. */
  smoothTargetTop: number | null
  /** scrollHeight - clientHeight */
  maxScrollTop: number
}): ScrollFollowDecision {
  if (input.gapPx <= 1) {
    return 'none'
  }
  if (input.mode === 'instant' || input.prefersReducedMotion) {
    return 'instant'
  }
  const smoothInFlight = input.smoothTargetTop != null
  if (smoothInFlight && input.maxScrollTop > input.smoothTargetTop + 1) {
    return 'instant'
  }
  if (smoothInFlight) {
    return 'none'
  }
  if (input.gapPx >= SCROLL_FOLLOW_EASE_GAP_PX) {
    return 'smooth'
  }
  return 'instant'
}
